<template>
  <div class="container">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Gestión de Topes y Precios</v-toolbar-title>
      </v-toolbar>
      <v-expansion-panels v-model="state" accordion class="mt-3">
        <v-expansion-panel>
          <v-expansion-panel-header
            >Tope de Turnos diarios</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <Topes />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Precios de Consulta</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <Topes esPrecio />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.stop="salir">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import Topes from "./Topes.vue";
import router from "../../../router/index.js";

export default {
  data() {
    return {
      state: null,
    };
  },
  methods: {
    salir() {
      router.push({ path: "/Home" });
    },
  },
  components: {
    Topes,
  },
};
</script>
